import React, { useEffect } from 'react';
import { FilterRoute } from '@zonofi/zono-money-store';
import {
  EmptyStateView,
  EndListView,
  FilterModal,
  PullRefreshContainer,
  SpinnerLoader,
} from '../../components';
import { isEmpty } from 'lodash';
import { SVGS } from '@zonofi/seller-hub/assets';
import { SemanticQueryCard, SemanticQueryCardSkeleton } from '../semantic-card';
import { useSemanticQueryList } from '../hooks';

interface SemanticQueryListContentProps {
  filterPage?: string;
  showFilter?: boolean;
  setShowFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  setQueryCount?: React.Dispatch<React.SetStateAction<string>>;
}

export const SemanticQueryListContent: React.FC<
  SemanticQueryListContentProps
> = ({
  filterPage,
  showFilter = false,
  setShowFilter = () => {},
  setQueryCount = () => {},
}) => {
  const {
    conversationQueryData,
    lastItemRef,
    refresh,
    onScroll,
    isEndOfList,
    isLoading,
    onQueryCardPress,
    totalQueries,
  } = useSemanticQueryList();

  useEffect(() => {
    if (totalQueries) {
      setQueryCount(String(totalQueries));
    }
  }, [totalQueries]);

  return (
    <>
      <PullRefreshContainer
        className="semantic-query__screen"
        onRefresh={refresh}
        onScroll={onScroll}
      >
        {isLoading ? (
          <SemanticQueryCardSkeleton />
        ) : isEmpty(conversationQueryData) ? (
          <EmptyStateView
            imageSrc={SVGS.NoSemanticQuery}
            message={'Query Analysis not Available'}
            description={
              'There are no conversations from the last\n20 Minutes to summarize.'
            }
          />
        ) : (
          <>
            <div className="semantic-query__list">
              {conversationQueryData?.map((query, index) => (
                <SemanticQueryCard
                  key={index}
                  query={query}
                  onPress={onQueryCardPress}
                  showDivider={index < conversationQueryData.length - 1}
                />
              ))}
            </div>
            <div ref={lastItemRef} className="semantic-query__sentinel" />
            {!isEndOfList && <SpinnerLoader />}
            {isEndOfList && <EndListView />}
          </>
        )}
      </PullRefreshContainer>

      <FilterModal
        onClose={() => setShowFilter(false)}
        open={showFilter}
        route={FilterRoute.SemanticQuery}
        filterPage={filterPage}
      />
    </>
  );
};
